import template from './selectedPitches.html';

class SelectedPitchesController {
  constructor($log) {
    this.$log = $log;
  }

  deletePitch(pitch) {
    switch (this.pitchType) {
      case 'platform':
        this.onDelete({
          platform: pitch,
          deleteIcon: true
        });
        break;
      case 'publication':
        this.onDelete({
          id: pitch.id,
          name: pitch.publicationName,
          website: pitch.website,
          active: false
        });
        break;
      default:
        this.$log.error('pitchType is either invalid or not defined in selectedPitches component');
    }
  }

  updatePublication(targetChange) {
    this.update({ change: targetChange });
  }
}

SelectedPitchesController.$inject = ['$log'];

const component = {
  template,
  bindings: {
    pitches: '<',
    onDelete: '&',
    pitchType: '@',
    update: '&'
  },
  controller: 'SelectedPitchesController'
};

export default function (ngModule) {
  ngModule.component('selectedPitches', component);
  ngModule.controller('SelectedPitchesController', SelectedPitchesController);
}
